import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ExpandGlyph = /*#__PURE__*/createElement("g", {
  id: "expand"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M20.6,18.5h5.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H17c-0.2,0-0.4,0-0.5,0.1c0,0,0,0,0,0c-0.4,0.2-0.7,0.4-0.8,0.8 c0,0,0,0,0,0c-0.1,0.2-0.1,0.4-0.1,0.5v9.4c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-5.8l13.1,13.1c0.3,0.3,0.7,0.4,1.1,0.4 s0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1L20.6,18.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M68.4,16.5C68.4,16.4,68.4,16.4,68.4,16.5c-0.2-0.4-0.5-0.7-0.8-0.8c0,0,0,0,0,0c-0.2-0.1-0.4-0.1-0.5-0.1h-9.4 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h5.8L50.3,31.6c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4 l13.1-13.1v5.8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V17C68.5,16.8,68.5,16.6,68.4,16.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M67,56.1c-0.8,0-1.5,0.7-1.5,1.5v5.8L52.4,50.3c-0.6-0.6-1.5-0.6-2.1,0s-0.6,1.5,0,2.1l13.1,13.1h-5.8 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H67c0.2,0,0.4,0,0.5-0.1c0,0,0,0,0,0c0.4-0.2,0.7-0.4,0.8-0.8c0,0,0,0,0,0 c0.1-0.2,0.1-0.4,0.1-0.5v-9.4C68.5,56.8,67.8,56.1,67,56.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M31.6,50.3L18.5,63.4v-5.8c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5V67c0,0.2,0,0.4,0.1,0.5c0,0,0,0,0,0 c0.2,0.4,0.4,0.7,0.8,0.8c0,0,0,0,0,0c0.2,0.1,0.4,0.1,0.5,0.1h9.4c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-5.8l13.1-13.1 c0.6-0.6,0.6-1.5,0-2.1S32.2,49.7,31.6,50.3z"
})));
const Expand = createSvg({
  name: 'expand',
  path: ExpandGlyph
});

export default Expand;
export { ExpandGlyph };
